import { LocationPageTemplate } from "@/components/LocationPageTemplate";

export default function MaerkischOderland() {
  return (
    <LocationPageTemplate
      page={{
        location: "Märkisch-Oderland",
        locationSlug: "maerkisch-oderland",
        keyword: "Haushaltsauflösung Märkisch-Oderland",
        metaTitle:
          "Haushaltsauflösung Märkisch-Oderland | Festpreis & Termin in 48h",
        metaDesc:
          "Professionelle Haushaltsauflösung im Landkreis Märkisch-Oderland. Schnelle, diskrete und besenreine Haushaltsauflösung zum Festpreis. Kostenlose Besichtigung!",
        heroSub:
          "Ihre zuverlässige Haushaltsauflösung in Märkisch-Oderland – schnell, diskret und besenrein zum Festpreis.",
        heroImg:
          "https://assets.cdn.filesafe.space/RcAk4NqqJiBX4hgBLewG/media/69909eeb899b888ab68a9a42.jpg",
        localIntro: (
          <>
            <p>
              Der Landkreis Märkisch-Oderland grenzt östlich an Berlin und ist
              geprägt von weitläufigen Landschaften, dörflichen Strukturen und
              wachsenden Vorstadtgemeinden wie Strausberg, Neuenhagen oder
              Petershagen/Eggersdorf. Bei Entrümpelungen in dieser Region geht
              es häufig um die Räumung von Einfamilienhäusern, Bauernhöfen oder
              großen Grundstücken mit Nebengelassen.
            </p>
            <p>
              Im Gegensatz zur Großstadt sind die logistischen Herausforderungen
              hier oft längere Anfahrtswege und die Entsorgung großer Mengen an
              Sperrmüll oder Gartenabfällen. Oftmals müssen komplette
              Grundstücke inklusive Schuppen, Garagen und Dachböden geräumt
              werden.
            </p>
            <p>
              Wir sind im gesamten Landkreis Märkisch-Oderland für Sie im
              Einsatz und bringen die nötigen Transportkapazitäten mit, um auch
              umfangreiche Räumungen zügig und professionell durchzuführen.
            </p>
          </>
        ),
        trustText:
          "Ob ein Einfamilienhaus in Strausberg oder ein Bauernhof auf dem Land – wir nehmen Ihnen die schwere Arbeit ab und stehen Ihnen zuverlässig zur Seite.",
        trustQuote:
          "Sehr gute Arbeit bei der Räumung unseres Hauses in Neuenhagen. Pünktlich, sauber und genau zum vereinbarten Preis.",
        challengesText: (
          <>
            <p>
              Die Entsorgung großer Mengen an Sperrmüll erfordert in
              Märkisch-Oderland oft die Koordination mit lokalen
              Entsorgungsbetrieben. Wir übernehmen die komplette Sortierung und
              fachgerechte Entsorgung für Sie, sodass Sie sich um nichts kümmern
              müssen.
            </p>
            <p>
              Bei der Räumung von großen Grundstücken oder Höfen setzen wir bei
              Bedarf auch Container ein, um die Arbeiten effizient
              abzuschließen. Die Diskretion gegenüber Nachbarn in dörflichen
              Strukturen ist uns dabei besonders wichtig.
            </p>
          </>
        ),
        reviews: [
          {
            text: "Das Team hat unser Haus in Strausberg sehr schnell und ordentlich entrümpelt. Toller Service!",
            author: "Kunde aus Strausberg",
          },
          {
            text: "Sehr freundlich und professionell. Die Wertanrechnung war sehr fair.",
            author: "Kundin aus Petershagen",
          },
          {
            text: "Alles wurde besenrein hinterlassen, genau wie versprochen. Keine versteckten Kosten.",
            author: "Familie aus Neuenhagen",
          },
        ],
        neighbors: [
          { name: "Marzahn-Hellersdorf", slug: "marzahn-hellersdorf" },
          { name: "Treptow-Köpenick", slug: "treptow-koepenick" },
          { name: "Berlin", slug: "berlin" },
        ],
        faqs: [
          {
            q: "Kommen Sie für eine Besichtigung nach Märkisch-Oderland?",
            a: "Ja, wir bieten kostenlose und unverbindliche Besichtigungstermine im gesamten Landkreis an.",
          },
          {
            q: "Entrümpeln Sie auch Scheunen oder große Schuppen?",
            a: "Selbstverständlich. Wir räumen komplette Grundstücke inklusive aller Nebengebäude.",
          },
          {
            q: "Wie lange dauert eine Haushaltsauflösung in der Regel?",
            a: "Eine normale Wohnungsauflösung ist oft an einem Tag erledigt. Bei größeren Häusern oder Höfen planen wir entsprechend mehr Zeit ein.",
          },
          {
            q: "Nehmen Sie auch alte Elektrogeräte mit?",
            a: "Ja, wir entsorgen alle Arten von Hausrat fachgerecht, einschließlich Elektro-Großgeräten.",
          },
        ],
      }}
    />
  );
}
